import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'app/shared/authentication/authentication.service';
import { ConfirmEmail } from 'app/shared/models/confirm-email.model';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.scss']
})
export class ConfirmEmailComponent implements OnInit {

  confirmEmail: ConfirmEmail;
  protected confirmEmailmessage: string = "Successfully confirmed email. Now you can log in.";

  constructor(private authenticationService: AuthenticationService, private router: Router, protected translateService: TranslateService) {
  }

  ngOnInit() {
    this.initializeObject();
    this.translateService.get(['account.confirmEmail.confirmEmailmessage'])
      .subscribe(translations => {
        this.confirmEmailmessage = translations['account.confirmEmail.confirmEmailmessage'];
      });
  }

  initializeObject() {
    if (this.confirmEmail == null) {
      this.confirmEmail = new ConfirmEmail();
    }
  }

  onSubmit(form: NgForm) {
    this.authenticationService.confirmEmail(form.value, () => this.router.navigate(['/account/login']), this.confirmEmailmessage);
  }
}
